<template>
  <div>
    <form>
      <b-row class="toolbar-ptc">
        <b-col>
          <router-link
            :to="{ name: 'product_list', params: { search: search} }"
            class="btn btn-ptc1"
            tag="button"
          >返回</router-link>
        </b-col>
        <b-col class="text-center title">線上點餐管理 / POS商品管理 / {{PosItem.IsGroup?'群組修改':'單品修改'}}</b-col>
        <b-col>
          <div class="text-right">
            <button type="button" class="btn btn-save" @click="confirm">儲存</button>
          </div>
        </b-col>
      </b-row>

      <div id="func-content">
        <b-card class="bg-default-card" title="POS資訊">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <label class="control-label col-md-1">商品：</label>
                <div class="col-md-4">
                  <input type="text" class="form-control" readonly="true" v-model="PosInfoName" />
                </div>

                <label class="control-label">POS分類：</label>
                <div class="col-md-3">
                  <input
                    type="text"
                    class="form-control"
                    readonly="true"
                    v-model="PosItem.AttributeName"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-card>

        <b-card class="bg-default-card" title="APP資訊">
          <div v-if="PosItem.IsGroup" class="row">
            <div class="col-lg-7">
              <div class="row mb-3">
                <label class="control-label col-md-3">群組名稱：</label>
                <div class="col-md-7">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="GroupItem.GroupName"
                    placeholder="請輸入群組名稱"
                    maxlength="30"
                    required
                  />
                  <div class="text-danger" v-if="valid_GroupName && !GroupItem.GroupName">{{valid_GroupName}}</div>
                </div>
              </div>
              <div class="row mb-3">
                <label class="control-label col-md-3">備註：</label>
                <div class="col-md-7">
                  <input
                    type="text"
                    name="Input_Memo"
                    class="form-control"
                    v-model.trim="Memo"
                    placeholder="請輸入備註"
                    maxlength="30"
                  />
                </div>
              </div>
              <div class="row mb-3">
                <label class="control-label col-md-3">群組標題：</label>
                <div class="col-md-4">
                  <input
                    type="text"
                    name="Input_OptionName"
                    class="form-control"
                    v-model.trim="GroupItem.OptionName"
                    maxlength="30"
                    required
                  />
                  <div class="text-danger" v-if="valid_GroupTitle && !GroupItem.OptionName">{{valid_GroupTitle}}</div>
                </div>
                <div class="col-md-4">
                  <b-checkbox v-model="GroupItem.IsChangItem">加價更換品項</b-checkbox>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="control-label">圖片上傳</label>
                  <input
                    type="file"
                    class="upload_input"
                    id="pic"
                    ref="inputer"
                    accept="image/*"
                    multiple
                    @change="handleFileChange"
                  />
                  <label class="upload_block" for="pic">
                    <span class="upload_icon">➕</span>
                    <img
                      class="upload_img"
                      v-if="img_url != undefined"
                      :src="file==undefined? img_url : img_url"
                    />
                  </label>
                  <br />
                  <div class="text-danger" v-if="valid_img_url">{{valid_img_url}}</div>
                  <span class="text-danger">※限制上傳一張圖片，建議尺寸為800x600</span>
                </div>
              </div>
            </div>
            <div class="col-lg-11">
              <div class="row">
                <label class="control-label col-md-2">群組項目：</label>
                <div class="col-md-10">
                  <div class="table-responsive">
                    <table class="table table-bordred table-striped">
                      <thead>
                        <tr>
                          <th></th>
                          <th>品項</th>
                          <th>時段</th>
                          <th>顯示名稱</th>
                          <th v-if="GroupItem.IsChangItem" width="100px">預設商品</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="Item in this.GroupItem.GroupItemList" :key="Item.ID">
                          <td>
                            <b-checkbox v-model="Item.AppShow" @change="changeAppShow(Item)"></b-checkbox>
                          </td>
                          <td>{{Item.Name}}</td>
                          <td>{{Item.PeriodName == '' ? '全時段':Item.PeriodName }}</td>
                          <td>
                            <input
                              type="text"
                              class="form-control"
                              v-model.trim="Item.AppName"
                              maxlength="10"
                            />
                          </td>
                          <td v-if="GroupItem.IsChangItem">
                            <b-checkbox
                              v-if="Item.AppShow && GroupItem.IsChangItem"
                              :key="Item.ID"
                              v-model="Item.GroupDefaultItem"
                              @change="changeGroupDefaultItem(Item)"
                            ></b-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="text-danger" v-if="valid_ItemMsg.valid_GroupAppName">{{valid_ItemMsg.valid_GroupAppName}}</div>
                    <div
                      class="text-danger"
                      v-if="valid_ItemMsg.valid_GroupDefaultItem"
                    >{{valid_ItemMsg.valid_GroupDefaultItem}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-lg-7">
              <div class="row mb-3">
                <label class="control-label col-md-3">商品名稱：</label>
                <div class="col-md-7">
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="AppName"
                    placeholder="請輸入商品名稱"
                    maxlength="30"
                    required
                  />
                  <div class="text-danger" v-if="valid_title&&!AppName">{{valid_title}}</div>
                </div>
              </div>
              <div class="row mb-3">
                <label class="control-label col-md-3">備註：</label>
                <div class="col-md-7">
                  <input
                    type="text"
                    name="Input_Memo"
                    class="form-control"
                    v-model.trim="Memo"
                    placeholder="請輸入備註"
                    maxlength="30"
                  />
                </div>
              </div>
              <div class="row mb-3">
                <label class="control-label col-md-3">時段：</label>
                <div class="col-md-7">
                  {{PeriodName == '' ? '全時段':PeriodName}}
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="control-label">圖片上傳</label>
                  <input
                    type="file"
                    class="upload_input"
                    id="pic"
                    ref="inputer"
                    accept="image/*"
                    multiple
                    @change="handleFileChange"
                  />
                  <label class="upload_block" for="pic">
                    <span class="upload_icon">➕</span>
                    <img
                      class="upload_img"
                      v-if="img_url != undefined"
                      :src="file==undefined? img_url : img_url"
                    />
                  </label>
                  <br />
                  <div class="text-danger" v-if="valid_img_url">{{valid_img_url}}</div>
                  <span class="text-danger">※限制上傳一張圖片，建議尺寸為800x600</span>
                </div>
              </div>
            </div>
          </div>
          <div role="tablist">
            <label class="control-label">調味項目：</label>
            <div v-for="(flavors,index) in this.ProductFlavors" :key="flavors.ID">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                <div class="btn btn-info row cardrow">
                  <div class="col-md-1">
                  <b-form-checkbox-group
                            v-model="CheckItemIDs"
                            :options="getFlavorsItemList(flavors.ProductFlavorItem,flavors.ProductFlavor.FlavorID,false)"
                            class="cardrow"
                          ></b-form-checkbox-group>
                  </div>
                  <div class="col-md-11">
                    <b-button
                    block
                    href="#"
                    v-b-toggle="'accordion-'+index"
                    variant="info"
                    :key="flavors.ID"
                  >{{flavors.FlavorName}}</b-button>
                  </div>
                </div>
                </b-card-header>
                <b-collapse :id="'accordion-'+index" visible role="tabpanel">
                  <b-card-body>
                    <div class="row">
                      <div class="col-md-12">
                        <b-form-group>
                          <b-form-checkbox-group
                            v-model="CheckItemIDs"
                            :options="getFlavorsItemList(flavors.ProductFlavorItem,flavors.ProductFlavor.FlavorID,true)"
                          ></b-form-checkbox-group>
                        </b-form-group>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-card>
      </div>
    </form>
  </div>
</template>
<script>
import { getFunctionPermission } from '../../../js/LoginUserFunction.js'
import { API_URL, fileUploadMaxSize } from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import axios from 'axios'
miniToastr.init()
export default {
  data () {
    return {
      id: 0,
      brandCode: '',
      // POS資訊
      PosInfoName: '',
      PosInfoAttribute: '',
      title: '',
      file: undefined,
      img_url: undefined,
      PosItem: {},
      GroupItem: {
        GroupName: '',
        OptionName: '',
        IsChangItem: false,
        GroupItemList: []
      },
      AppName: '',
      Memo: '',
      PeriodName: '',
      action: 1,
      valid_errMsg: false,
      valid_title: '',
      valid_GroupName: '',
      valid_GroupTitle: '',
      valid_img_url: '',
      search: {},
      currentPage: 1, // 記錄查詢條件
      API_URL: API_URL,
      FunctionPermission: 0,
      ProductFlavors: [],
      CheckItemIDs: [], // 已被勾選的項目(含調味必選條件)
      valid_ItemMsg: {
        valid_GroupDefaultItem: '',
        valid_GroupAppName: ''
      }
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F16') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    } else if (this.FunctionPermission < 2) {
      this.$router.push({ name: 'product_list' })
      return
    }

    var params = this.$route.params
    if (params.item === undefined) {
      this.$router.push({ name: 'product_list' })
      return
    }

    this.action = params.action
    this.search = params.search

    this.PosItem = params.item.Product
    this.id = this.PosItem.ID
    this.brandCode = this.search.queryBrandsCode
    this.PosInfoName = this.PosItem.Code + ' ' + this.PosItem.Name
    this.img_url = this.PosItem.ImageURL

    if (this.PosItem.IsGroup) {
      this.getGroupData(this.id)
    } else {
      this.getProductData(this.id)
    }
  },
  props: {
    value: {
      default: undefined
    }
  },
  methods: {
    getProductData (id) {
      return axios
        .post(API_URL + '/web/shopping/GetProductDetailOne/v1', {
          Status: 1,
          ProductID: id,
          BrandCode: this.brandCode
        })
        .then(response => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            var ProductDetail = response.data.data
            this.AppName = ProductDetail.Product.AppName
            this.Memo = ProductDetail.Product.Memo
            this.PeriodName = ProductDetail.Product.PeriodName
            this.img_url = ProductDetail.Product.ImageUrl
            if (ProductDetail.ProductFlavors) {
              this.ProductFlavors = ProductDetail.ProductFlavors.sort(
                (a, b) => {
                  return a.ProductFlavor.FlavorID > b.ProductFlavor.FlavorID ? 1 : -1
                }
              )
            }
            console.log(this.ProductFlavors)
            this.SetFlavorsCheckItems()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            // this.items = []
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch(error => {
          // this.items = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    getGroupData (id) {
      return axios
        .post(API_URL + '/web/shopping/GetProductGroupDetailOne/v1', {
          Status: 1,
          GroupID: id
        })
        .then(response => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            var ProductGroupDetail = response.data.data
            this.GroupItem.GroupName =
              ProductGroupDetail.ProductGroup.AppGroupName
            this.GroupItem.OptionName =
              ProductGroupDetail.ProductGroup.AppOptionName
            this.GroupItem.IsChangItem =
              ProductGroupDetail.ProductGroup.IsChangItem
            this.GroupItem.GroupItemList = ProductGroupDetail.GroupItems
            this.Memo = ProductGroupDetail.ProductGroup.Memo
            this.img_url = ProductGroupDetail.ProductGroup.ImageURL
            if (ProductGroupDetail.ProductFlavors) {
              this.ProductFlavors = ProductGroupDetail.ProductFlavors.sort(
                (a, b) => a.ProductFlavor.FlavorID > b.ProductFlavor.FlavorID
              )
            }
            this.SetFlavorsCheckItems()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            // this.items = []
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch(error => {
          // this.items = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    SetFlavorsCheckItems () {
      if (this.ProductFlavors) {
        this.ProductFlavors.forEach(x => {
          if (x.ProductFlavor.IsRequired) {
            this.CheckItemIDs.push('FlavorID' + x.ProductFlavor.FlavorID)
          }

          x.ProductFlavorItem.forEach(y => {
            if (y.ProductFlavorItems.ID !== 0) {
              this.CheckItemIDs.push(y.ProductFlavorItems.FlavorItemID)
            }
          })
        })
      }
    },
    getFlavorsItemList (list, FlavorID, IsItem) {
      var FlavorsItems = []

      if (IsItem) {
        list.forEach(x => {
          FlavorsItems.push({
            text: x.ProductFlavorItemsName,
            value: x.ProductFlavorItems.FlavorItemID
          })
        })
      } else {
        FlavorsItems.push({
          text: '必選',
          value: 'FlavorID' + FlavorID
        })
      }
      return FlavorsItems
    },
    confirm () {
      this.valid_errMsg = false
      this.valid_ItemMsg.valid_GroupAppName = ''

      // 檢查預設商品
      if (this.PosItem.IsGroup && this.GroupItem.IsChangItem) {
        if (
          this.GroupItem.GroupItemList.filter(
            x => x.AppShow && x.GroupDefaultItem
          ).length <= 0
        ) {
          this.valid_errMsg = true
          this.valid_ItemMsg.valid_GroupDefaultItem = '必需選擇預設商品'
        }
      }
      if (!this.PosItem.IsGroup && !this.AppName) {
        this.valid_errMsg = true
        this.valid_title = '商品名稱為必填'
      }
      if (this.PosItem.IsGroup) {
        if (this.GroupItem.GroupName.trim() === '') {
          this.valid_errMsg = true
          this.valid_GroupName = '群組名稱為必填'
        }
        if (this.GroupItem.GroupItemList.filter(x => x.AppName.trim() === '').length > 0) {
          this.valid_errMsg = true
          this.valid_ItemMsg.valid_GroupAppName = '顯示名稱為必填'
        }
      }
      if (this.valid_errMsg) {
        this.$parent.verificationErrMsg()
      } else {
        this.save()
      }
    },
    save () {
      this.$parent.Loading = true

      var FlavorsList = []
      // 先整理有必選的商品調味
      this.CheckItemIDs.filter(x => typeof x === 'string').forEach(x => {
        var iFlavorID = Number(x.replace('FlavorID', ''))
        var tempF = this.ProductFlavors.filter(
          y => y.ProductFlavor.FlavorID === iFlavorID
        )[0].ProductFlavor

        FlavorsList.push({
          ID: tempF.ID,
          FlavorID: tempF.FlavorID,
          IsRequired: true,
          FlavorsItemList: []
        })
      })

      // 整理被選擇的商品調味項目 //&& x.indexOf('FlavorID') < 0
      this.CheckItemIDs.filter(x => typeof x === 'number').forEach(x => {
        var temp = this.ProductFlavors.map(y => {
          var tempFI = y.ProductFlavorItem.filter(
            fi => fi.ProductFlavorItems.FlavorItemID === x
          )[0]
          if (tempFI !== undefined) {
            return {
              tempF: y.ProductFlavor,
              tempFI: tempFI.ProductFlavorItems
            }
          }
        }).filter(x => x !== undefined)[0]
        var ArrIndex = -1
        FlavorsList.forEach((x, index) => {
          if (x.FlavorID === temp.tempF.FlavorID) ArrIndex = index
        })

        if (ArrIndex > -1) {
          var tempItem = {
            ID: temp.tempFI.ID,
            ProductFlavorID: temp.tempFI.ProductFlavorID,
            FlavorItemID: temp.tempFI.FlavorItemID
          }
          FlavorsList[ArrIndex].FlavorsItemList.push(tempItem)
        } else {
          FlavorsList.push({
            ID: temp.tempF.ID,
            FlavorID: temp.tempF.FlavorID,
            IsRequired: false,
            FlavorsItemList: [
              {
                ID: temp.tempFI.ID,
                ProductFlavorID: temp.tempFI.ProductFlavorID,
                FlavorItemID: temp.tempFI.FlavorItemID
              }
            ]
          })
        }
      })

      var arrAll = {}
      var webUrl = ''

      if (this.PosItem.IsGroup) {
        webUrl = API_URL + '/web/shopping/UpdateProductGroupOne/v1'

        var GroupItemList = []

        this.GroupItem.GroupItemList.forEach(x => {
          GroupItemList.push({
            ID: x.ID,
            AppName: x.AppName,
            GroupDefaultItem: x.GroupDefaultItem,
            AppShow: x.AppShow
          })
        })

        arrAll = {
          ID: this.id,
          AppGroupName: this.GroupItem.GroupName,
          AppOptionName: this.GroupItem.OptionName,
          Memo: this.Memo,
          IsChangItem: this.GroupItem.IsChangItem,
          GroupItemList: GroupItemList,
          FlavorsList: FlavorsList
        }
      } else {
        webUrl = API_URL + '/web/shopping/UpdateProductOne/v1'

        arrAll = {
          ID: this.id,
          AppName: this.AppName,
          memo: this.Memo,
          FlavorsList: FlavorsList
        }
      }

      let formData = new FormData()
      formData.append('image', this.file)
      formData.append('imgUrl', this.img_url)
      formData.append('data', JSON.stringify(arrAll))
      var config = {
        headers: {
          'Content-Type': undefined
        }
      }

      // var webUrl = API_URL + this.PosItem.IsGroup ? '/web/shopping/UpdateProductGroupOne/v1' : '/web/shopping/UpdateProductOne/v1'

      return axios
        .post(webUrl, formData, config)
        .then(response => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('商品資料已更新')
            this.$router.push({
              name: 'product_list',
              params: { search: this.search }
            })
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料更新失敗')
            console.log(response.data.message)
          }
        })
        .catch(error => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料更新失敗')
          console.log(error)
        })
    },
    handleFileChange (e) {
      this.valid_img_url = ''
      let inputDOM = this.$refs.inputer
      this.file = inputDOM.files[0]
      this.$emit('input', this.file)
      if (!this.imgPreview(this.file)) {
        this.$refs.inputer.value = ''
        this.img_url = undefined
      }
    },
    imgPreview (file) {
      var rtn = false
      let self = this
      if (!file || !window.FileReader) return
      if (/^image/.test(file.type)) {
        if (file.size > fileUploadMaxSize) {
          miniToastr.error('圖檔大小不可超過 5MB')
        } else {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onloadend = function () {
            self.img_url = this.result
          }
          rtn = true
        }
      } else {
        miniToastr.error('請選擇正確圖檔')
      }
      return rtn
    },
    changeAppShow (params) {
      if (!params.AppShow) {
        params.GroupDefaultItem = false
      }
    },
    changeGroupDefaultItem (params) {
      this.GroupItem.GroupItemList.forEach(x => {
        if (x.ID === params.ID) {
          x.GroupDefaultItem = !x.GroupDefaultItem
          if (x.GroupDefaultItem) {
            this.valid_ItemMsg.valid_GroupDefaultItem = ''
          }
        } else {
          x.GroupDefaultItem = false
        }
      })
    }
  },
  watch: {
    sdate: function (val) {
      if (this.valid_errMsg) {
        if (!val) {
          this.valid_sdate = '日期格式不正確'
        } else if (val < this.today) {
          this.valid_sdate = '開始日期不得小於系統時間'
        } else {
          this.valid_sdate = ''
        }
      }
    },
    edate: function (val) {
      if (this.valid_errMsg) {
        if (!val) {
          this.valid_edate = '日期格式不正確'
        } else if (val < this.sdate) {
          this.valid_edate = '結束日期不得小於開始日期'
        } else {
          this.valid_edate = ''
        }
      }
    }
  }
}
</script>
<style scoped>
.upload_block {
  position: relative;
  width: 257px;
  height: 220px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background: #f1f1f1;
  border: 3px dashed #d6d4d4;
}
.upload_input {
  display: none;
}
.upload_img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}
.upload_icon {
  font-weight: bold;
  font-size: 200%;
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  top: 40%;
}
.block {
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 55pt;
  left: 25pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 2;
}
.bk_img {
  width: 100%;
  height: 100%;
}
.cardrow {
  margin-right:0px;
  margin-left: 0px;
  display: flex ;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/product/Edit.vue